import { IResponse } from '@estee/elc-service';
import { HttpTransport } from '@estee/elc-http-transport';
import { ELCLogger, TriggerType } from '@estee/elc-logging';
import { query, serviceQueries } from '@estee/elc-service-bus';

interface ICountriesResponse {
    countries: ICountry[];
}

export interface ICountry {
    id: string;
    name: string;
    callingCode: string;
}

interface IRampSdApiSdk {
    businessUnitId: string;
    httpTransport: HttpTransport;
    logger: ELCLogger;
}

export class RampSdApiSdk {
    private businessUnitId: string;
    private countriesUrl: string;
    private httpTransport: HttpTransport;
    private logger: ELCLogger;

    constructor(config: IRampSdApiSdk) {
        this.countriesUrl = '/stardust-foundation-countries-v0/countries';
        this.httpTransport = config.httpTransport;
        this.businessUnitId = config.businessUnitId;
        this.logger = config.logger;
    }

    public setupGlobalHeaders = async (): Promise<void> => {
        this.httpTransport.addGlobalHeaders({
            'Business-Unit': this.businessUnitId,
            AuthorizationToken:
                (await query(serviceQueries.GET_LEGACY_GUEST_AUTH_TOKEN)) || undefined
        });
    };

    public getAllCountries = async (): Promise<ICountry[] | null> => {
        try {
            await this.setupGlobalHeaders();
            const response: IResponse<ICountriesResponse> = await this.httpTransport.get<
                ICountriesResponse
            >(this.countriesUrl);

            if (response.data) {
                return response.data.countries;
            }

            return null;
        } catch (error) {
            this.logger.error({
                message: `Unable to get countries from ${this.countriesUrl}`,
                triggerType: TriggerType.api
            });

            return null;
        }
    };
}
